import styled from 'styled-components';
import { motion } from 'framer-motion';
export var Container = styled.div.withConfig({
  displayName: "Percentilestyles__Container",
  componentId: "keen-query-creator__sc-1nnwnxj-0"
})(["&&&{width:68px;position:relative;}&&& input::-webkit-outer-spin-button,&&& input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&&& input[type='number']{-moz-appearance:textfield;}"]);
export var TooltipContainer = styled(motion.div).withConfig({
  displayName: "Percentilestyles__TooltipContainer",
  componentId: "keen-query-creator__sc-1nnwnxj-1"
})(["&&&{position:absolute;left:70%;top:70%;pointer-events:none;z-index:1;width:200px;font-family:'Lato Regular',sans-serif;font-size:14px;}"]);